import { mutationProcedure } from '../trpc/common.js';
import { z } from 'zod/v4-mini';
import path from 'path';
import { spawnSync } from 'child_process';
import type { ApiParams } from '../types/ApiParams.js';
import { formatLocation } from '@ms-cloudpack/path-utilities';
import { matchingZodObject } from '../utilities/matchingZodObject.js';
import type { OpenFilePathInput } from './openFilePath.js';

export interface OpenCodeEditorInput extends OpenFilePathInput {
  line?: number;
  column?: number;
}

const ZodOpenCodeEditorInput = matchingZodObject<OpenCodeEditorInput>({
  rootPath: z.string(),
  relativePath: z.optional(z.string()),
  line: z.optional(z.number()),
  column: z.optional(z.number()),
});

/**
 * Open a file or folder in VS Code.
 */
export function openCodeEditor(params: ApiParams<OpenCodeEditorInput, never>): void {
  const {
    input: { rootPath, relativePath, line, column },
  } = params;
  const fullPath = formatLocation({ file: path.resolve(rootPath, relativePath || ''), line, column });

  console.log(`Opening VSCode with path: ${fullPath}`);

  spawnSync('code', ['--goto', fullPath], { cwd: rootPath, stdio: 'inherit' });
}

// Attach a trpc procedure to the function.
openCodeEditor.procedure = mutationProcedure<OpenCodeEditorInput, void>(
  openCodeEditor,
  ZodOpenCodeEditorInput,
  z.void(),
);
